import { totesApi } from "./totes";

export const {
  useGetTotesQuery,
  useStageTotesMutation,
  useLoadTotesMutation,
  useTransferMutation,
  useVerifyTotesMutation,
  useScanLabelMutation,
  usePlaceLabelMutation,
  useConfirmTotePositionMutation,
  useConfirmAllTotePositionsMutation,
  useAddToteMutation
} = totesApi;
